import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../utils/firebase';

const MatchSchedule = () => {
    const { leagueId, startDate, endDate, print, header } = useParams();
    const [matches, setMatches] = useState([]);
    const [leagueSettings, setLeagueSettings] = useState({});
    const [leagueData, setLeagueData] = useState({});

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            setLeagueData(data);
            if (data) {
                setLeagueSettings(data.settings);
            } else {
                console.error('No settings found for the given leagueId.');
            }
            if (print === 'true') {
                setTimeout(() => {
                    window.print();
                }, 100); // 2 seconds delay
            }
        }, (error) => {
            console.error('Error fetching league settings from Firebase:', error);
        });
    }, [leagueId]);

    useEffect(() => {
        const matchesRef = ref(database, `leagues/${leagueId}/matches`);
        onValue(matchesRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const allMatches = Object.values(data);
                const filteredMatches = allMatches.filter(match =>
                    match.dateTime >= parseInt(startDate) &&
                    match.dateTime <= parseInt(endDate)
                );
                setMatches(filteredMatches);
            } else {
                console.log('No matches found for the given leagueId.');
            }
        }, (error) => {
            console.error('Error fetching data from Firebase:', error);
        });
    }, [leagueId, startDate, endDate]);

    const formatDate = (timestamp) => {
        const options = { weekday: 'long', month: 'short', day: 'numeric' };
        return new Date(timestamp * 1000).toLocaleDateString(leagueSettings.language, options);
    };

    const formatTime = (timestamp) => {
        const options = { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: leagueSettings.timeZone };
        return new Date(timestamp * 1000).toLocaleTimeString(leagueSettings.language, options);
    };

    const formatRange = (start, end) => {
        const startDate = new Date(parseInt(start) * 1000);
        const endDate = new Date(parseInt(end) * 1000);
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return `${startDate.toLocaleDateString(leagueSettings.language, options)} - ${endDate.toLocaleDateString(leagueSettings.language, options)}`;
    };

    return (
        <div style={{backgroundColor: '#ffffff'}}>
            <div className={'modern-report report-container'}>
                <div className="modern-report-container">
                    {header === 'true' && (
                        <div className={'modern-report-header'}>
                            <h1>Match Schedule</h1>
                            <h3>{leagueData.name}</h3>
                            <h4>{leagueData.parentGroup}</h4>
                            <h4>{formatRange(startDate, endDate)}</h4>
                        </div>
                    )}

                    <table>
                        <thead>
                            <tr>
                                <th width="60%">Date</th>
                                <th width="40%">Time</th>
                            </tr>
                        </thead>
                        <tbody>
                        {Array.isArray(matches) && matches
                            .sort((a, b) => Number(a.dateTime) - Number(b.dateTime))
                            .map((match, index) => (
                                <tr key={index}>
                                    <td>{formatDate(match.dateTime)}</td>
                                    <td>{formatTime(match.dateTime)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MatchSchedule;